import { SortDirectionType, SortOptionsType } from './enums';
import { PrimaryGuest } from './primary-guest.api';

export interface ProfilesSearchResponse {
  Items: PrimaryGuest[];
  Page: number;
  PageSize: number;
  HasMore: boolean;
}

export interface ProfilesSearchQuery {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  personId?: string;
  membershipId?: string;
  location?: ProfileLocationFilter | null;
  sort: SortOptionsType;
  sortDirection: SortDirectionType;
}

export interface ProfileSearchRequest {
  PersonId: number | null;
  FirstName: string | null;
  LastName: string | null;
  Email: string | null;
  Phone: string | null;
  MembershipId: string | null;
  Location: { Code: string; TypeCode: ProfileLocationType } | null;
  SortBy: ProfileSortBy | null;
  SortDirection: ProfileSortDirection | null;
  Page: number;
  PageSize: number;
}

export enum ProfileLocationType {
  Hotel = 'Hotel',
  Venue = 'Venue',
}

export interface ProfileLocationFilter {
  typeCode: ProfileLocationType;
  code: string;
}

export enum ProfileSortBy {
  LastNameFirstName = 'LastNameFirstName',
  Id = 'Id',
}

export enum ProfileSortDirection {
  Ascending = 'Ascending',
  Descending = 'Descending',
}
